import { useMemo } from 'react';
import { fonts as createFontsTheme } from '../theme/fonts';
export const useUpdateThemeWithFontBrightness = (theme, customFontBrightness) => {
    const fonts = useMemo(() => createFontsTheme({
        themeVariables: Object.assign(Object.assign({}, theme.themeVariables), { fontBrightness: customFontBrightness }),
    }), [customFontBrightness, theme.themeVariables]);
    const updatedTheme = useMemo(() => (Object.assign(Object.assign({}, theme), { fonts, themeVariables: Object.assign(Object.assign({}, theme.themeVariables), { fontBrightness: customFontBrightness }) })), [customFontBrightness, fonts, theme]);
    return updatedTheme;
};
//# sourceMappingURL=useUpdateThemeWithFontBrightness.js.map